import { render, staticRenderFns } from "./Inventoryfilter.vue?vue&type=template&id=2b8287ff&"
import script from "./Inventoryfilter.vue?vue&type=script&lang=js&"
export * from "./Inventoryfilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports